export const GET_WISHLIST = "GET_WISHLIST";
export const WISHLIST_ERROR = "WISHLIST_ERROR";
export const TOGGLE_WISHLIST = "TOGGLE_WISHLIST";
